import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/home.svg';
import { Icon } from '../Icon/Icon';
export const HomeIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
